export const DEFAULT_TITLE = 'is now a member of';
export const DEFAULT_BADGE = { icon: 'sparkles', text: 'New Member' };
